import * as React from 'react'
import StepTitle from '../components/step-title'
import SubHeader from '../components/sub-header'
import { withConfig } from '../modules/config'
import { withSubmission } from '../modules/submission'
import { withNavigation } from '../modules/navigation'
import { withRouteBlocker } from '../modules/route-blocker'
import { withQuoteSupport } from '../modules/quote-support'
import { withScrollToTop } from '../../common/modules/scroll-to-top'

import './payment-by-card.css'


@withSubmission
@withNavigation
@withRouteBlocker
@withQuoteSupport
@withScrollToTop
@withConfig
class PaymentByCard extends React.Component<any, any>{

    
    onCancel(){
        console.log("On cancel")
        this.props.actions.navigation.changeRoute("/payment");
    }


    componentWillMount(){
        
        const endpoint = this.props.quoteSupport.endpoints.paymentInitiate;
        this.props.actions.submission.post(endpoint,  this.setupBraintree.bind(this), {});
    }


    setupBraintree(clientToken, environment) {
        console.log("Setup braintree")
        var deviceData = null;

        const onReady = braintreeInstance => {
            deviceData = braintreeInstance.deviceData;
        }

        const onPaymentMethodReceived = paymentMethodDetails => {
            console.log("On paymentMethodDetails received");
            console.log( paymentMethodDetails );
            this.authorise(paymentMethodDetails.nonce, deviceData)
        }

        const purchaseButton = document.querySelector('#purchase');
        window["braintree"].dropin.create({
            authorization: this.props.fields.paymentClientToken,
            selector: '#braintree'
        }, function (err, instance) {
            if(purchaseButton === null) throw(new Error("Button not found"));
            purchaseButton.addEventListener('click', function () {
                instance.requestPaymentMethod(function (err, payload) {
                    onPaymentMethodReceived(payload);
                });
            })
        });
    }


    authorise(nonce, deviceData) {
        console.log("Authorise")
        const endpoint = this.props.quoteSupport.endpoints.paymentAuthorise;
        console.log("Axios")
        const dataToSend = {
            paymentMethodNonce: nonce,
            deviceData
        }
        
        this.props.actions.submission.post(endpoint, this.proceed.bind(this), dataToSend);
    }


    proceed(){
        
        const config = this.props.config;

        //GA Ecommerce tracking for online payments

        // Includes Coverage Type for Contents
        if(config.project == 'contents'){
        window["dataLayer"] = window["dataLayer"] || [];
        window["dataLayer"].push({
            'event': 'paymentOnlineSuccess', 
            'transactionId': this.props.fields.quoteNumber,         // String - Quote number
            'transactionAffiliation': 'Online: CreditCard',                   // String - Payment method
            'transactionTotal': this.props.fields.totalPayable,     // Numeric - Total amount paid
            'transactionProducts':[{
                'sku': this.props.fields.quoteNumber,               // String - Quote number
                'name': this.props.fields.coverageType+" " +config.project,                             // String - Product name
                'category': config.project,                           // String - Product category
                'price': this.props.fields.totalPayable,            // Numeric - Total amount paid
                'quantity': 1                                       // Integer - Leave set to 1
            }]
        });
        }

        //Coverage type need not be displayed for other products
        else{
            window["dataLayer"] = window["dataLayer"] || [];
            window["dataLayer"].push({
                'event': 'paymentOnlineSuccess', 
                'transactionId': this.props.fields.quoteNumber,         // String - Quote number
                'transactionAffiliation': 'Online: CreditCard',                   // String - Payment method
                'transactionTotal': this.props.fields.totalPayable,     // Numeric - Total amount paid
                'transactionProducts':[{
                    'sku': this.props.fields.quoteNumber,               // String - Quote number
                    'name': config.project,                             // String - Product name
                    'category': config.project,                           // String - Product category
                    'price': this.props.fields.totalPayable,            // Numeric - Total amount paid
                    'quantity': 1                                       // Integer - Leave set to 1
                }]
            });

        }


        this.props.actions.navigation.changeRoute("/payment-result");
    }


    render(){
        const {
            totalPayable
        } = this.props.fields;

        const handleSubmit = (event)=> {
            event.preventDefault();
        };

        return (
            <div className="row">
                <StepTitle>Pay by card</StepTitle>
                <SubHeader>Your payment details</SubHeader>

                <form className="col-12 pt-4" id="payment-form" method="post" onSubmit={handleSubmit}>
                    <div id="braintree"></div>
                    <button className="btn btn-primary btn-lg mr-2 mt-4" onClick={ this.onCancel.bind(this) }>Cancel</button>
                    <input id="purchase"  className="btn btn-primary btn-lg mt-4 pull-right" type="submit" value={'Pay $' + totalPayable} />
                </form>
            </div>
        )
    }

}


export default PaymentByCard;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/routes/payment-by-card.tsx